import React from 'react';
import { PredefinedRoles } from 'constants/constants';
import { getRole } from 'utility/decode-jwt';

export const menuItemsList = (t: any) => {
  const roles = getRole();
  const isAdminRole = Array.isArray(roles)
    ? roles.includes(PredefinedRoles.SUPER_ADMINISTRATOR)
    : roles === PredefinedRoles.SUPER_ADMINISTRATOR;

  const administrationSubMenuItems = [
    {
      key: 'users',
      label: t(
        isAdminRole ? 'side-bar:administration.users' : 'side-bar:administration.employees',
        isAdminRole ? 'Users' : 'Employees',
      ),
      path: '/users',
      claimName: 'users',
    },
    {
      key: 'user-groups',
      label: t(
        isAdminRole ? 'side-bar:administration.user-groups' : 'side-bar:administration.permissions',
        isAdminRole ? 'User Groups' : 'Permissions',
      ),
      path: '/user-groups',
      claimName: 'user-groups',
    },
  ];

  const configurationsSubMenuItems = [
    {
      key: 'email',
      label: t('side-bar:configurations.email', 'Email'),
      path: '/email',
      checkOnlyPermission: true,
      claimName: 'settings:manage-email',
    },
    {
      key: 'translations',
      label: t('side-bar:configurations.translations', 'Translations'),
      path: '/translations',
      claimName: 'translations',
    },
    {
      key: 'languages',
      label: t('side-bar:configurations.languages', 'Languages'),
      path: '/languages',
      claimName: 'languages',
    },
    {
      key: 'codebook-types',
      label: t('side-bar:configurations.codebook-types', 'Codebook Types'),
      path: '/codebook-types',
      claimName: 'codebook-types',
    },
    {
      key: 'debt-collection',
      label: t('side-bar:configurations.debt-collection', 'Debt Collection'),
      path: '/debt-collection',
      checkOnlyPermission: true,
      claimName: 'debt-collection:manage',
    },
  ];

  return {
    ...(isAdminRole
      ? {}
      : {
          dashboard: {
            key: 'dashboard',
            label: t('side-bar:dashboard', 'Dashboard'),
            icon: 'bar-chart-2',
            path: '/dashboard',
          },
        }),
    organizations: {
      key: 'organizations',
      label: t('side-bar:organizations', 'Organizations'),
      icon: 'user',
      path: '/organizations',
      claimName: 'organizations',
    },
    projects: {
      key: 'projects',
      label: t('side-bar:projects', 'Projects'),
      icon: 'layers',
      path: '/projects',
      claimName: 'projects',
    },
    // contractors: {
    //   key: 'contractors',
    //   label: t('side-bar:contractors', 'Contractors'),
    //   icon: 'tool',
    //   path: '/contractors',
    //   //claimName: 'contractors',
    // },
    suppliers: {
      key: 'suppliers',
      label: t('side-bar:suppliers', 'Suppliers'),
      icon: 'clipboard',
      subMenuItems: [
        {
          key: 'suppliers-list',
          label: t('side-bar:suppliers.list', 'List of Suppliers'),
          path: '/suppliers',
          claimName: 'suppliers',
        },
        {
          key: 'supplier-payments',
          label: t('side-bar:suppliers.payments', 'Payments'),
          path: '/supplier-payments',
          checkOnlyPermission: true,
          claimName: 'suppliers:manage-payments',
        },
      ],
    },
    clients: {
      key: 'clients',
      label: t('side-bar:clients', 'Clients'),
      icon: 'user',
      path: '/clients',
      claimName: 'clients',
    },
    tasks: {
      key: 'tasks',
      label: t('side-bar:tasks', 'Tasks'),
      icon: 'check-square',
      path: '/tasks',
      claimName: 'tasks',
    },
    unitCategories: {
      key: 'buildings',
      label: t('side-bar:buildings', 'Buildings'),
      icon: 'box',
      path: '/buildings',
      claimName: 'unit-categories',
    },
    deals: {
      key: 'deals',
      label: t('side-bar:deals', 'Deals'),
      icon: 'trending-up',
      path: '/deals',
      claimName: 'deals',
    },
    payments: {
      key: 'payments',
      label: t('side-bar:payments', 'Payments'),
      icon: 'dollar-sign',
      subMenuItems: [
        {
            key: 'upcoming-payments',
            label: t('side-bar:payments.upcoming', 'Upcoming Payments'),
            path: '/payments/upcoming',
            claimName: 'deals', // Using deals permission since it's related to deal cash flows
        },
        {
          key: 'delayed-payments',
          label: t('side-bar:payments.delayed', 'Delayed Payments'),
          path: '/payments/delayed',
          claimName: 'deals',
        },
      ],
    },
    administration: {
      key: 'administration',
      label: t('side-bar:administration', 'Administration'),
      icon: 'users',
      subMenuItems: administrationSubMenuItems,
    },
    configurations: {
      key: 'configurations',
      label: t('side-bar:configurations', 'Configurations'),
      icon: 'settings',
      subMenuItems: configurationsSubMenuItems,
    },
    // logs: {
    //   key: 'logs',
    //   label: t('side-bar:logs', 'Logs'),
    //   path: '/logs',
    //   icon: 'rewind',
    //   claimName: 'logs',
    // },
  };
};
